import { z } from 'zod';

// ─── Auth ────────────────────────────────────────────────────
export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
});

export const registerSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  name: z.string().min(1, 'Name is required'),
});

// ─── Contracts ───────────────────────────────────────────────
export const contractSchema = z.object({
  name: z.string().min(1, 'Contract name is required'),
  type: z.enum(['ppa', 'msa', 'sla', 'service'], { required_error: 'Type is required' }),
  status: z.enum(['draft', 'active', 'expired', 'terminated']).default('draft'),
  value: z.coerce.number().min(0, 'Value must be positive').optional(),
  start_date: z.string().min(1, 'Start date is required'),
  end_date: z.string().min(1, 'End date is required'),
});

// ─── Invoices ────────────────────────────────────────────────
export const invoiceSchema = z.object({
  invoice_number: z.string().min(1, 'Invoice number is required'),
  contract_id: z.string().min(1, 'Contract is required'),
  total: z.coerce.number().min(0.01, 'Amount must be greater than 0'),
  due_date: z.string().min(1, 'Due date is required'),
  description: z.string().optional(),
});

// ─── Settings ────────────────────────────────────────────────
export const profileSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  phone: z.string().optional(),
});

export const changePasswordSchema = z.object({
  current_password: z.string().min(1, 'Current password is required'),
  new_password: z.string().min(6, 'New password must be at least 6 characters'),
  confirm_password: z.string().min(1, 'Please confirm your password'),
}).refine((data) => data.new_password === data.confirm_password, {
  message: 'Passwords do not match',
  path: ['confirm_password'],
});

// ─── Users ───────────────────────────────────────────────────
export const inviteUserSchema = z.object({
  email: z.string().email('Invalid email address'),
  name: z.string().optional(),
  role: z.enum(['org_admin', 'org_user', 'viewer'], { required_error: 'Role is required' }),
  org_id: z.string().optional(),
});

// ─── Organizations ───────────────────────────────────────────
export const organizationSchema = z.object({
  name: z.string().min(1, 'Organization name is required'),
  domain: z.string().min(1, 'Domain is required'),
  industry: z.string().optional(),
});
